// @flow

import { Wrapper } from "./Button.styles";
import React from "react";
import Spinner from "../Spinner";
import type { Color, Gradient, Size } from "views/resources/theme";

interface Props {
	isLoading: boolean;
	size: Size;
	disabled: boolean;
	color: Color;
	gradient?: Gradient;
	children: string;
	invertedColor: boolean;
	onClick(): void;
}

const Button = ({
	isLoading,
	disabled,
	color,
	gradient,
	children,
	size,
	onClick,
	invertedColor,
}: Props) => {
	const scolor: string = disabled && !isLoading ? "disabled" : color;
	return (
		<Wrapper
			isLoading={isLoading}
			invertedColor={invertedColor}
			color={scolor}
			disabled={disabled}
			size={size}
			gradient={gradient}
			onClick={onClick}
		>
			{isLoading ? <Spinner color="#fff" button size={size} /> : children}
		</Wrapper>
	);
};

export default Button;
